import { FC } from 'react'
import { useGetMonitoringPagesQuery } from 'src/reactQuery/useGetMonitoringPagesQuery'
import { Cards } from './Cards'
import classes from './savedCompetitors.module.scss'
import { AdLibraryEmptyState } from '../EmptyState'
import { ReactComponent as SavedCompetitorsEmptyIcon } from '../saved-competiros-empty.svg'

export const SavedCompetitors: FC = () => {
  const { data, isLoading } = useGetMonitoringPagesQuery()
  const pages = data?.data || []
  // pages is [] before the response lands, which is indistinguishable from
  // genuinely having none — so the loading branch must come first, otherwise
  // the widget asserts "No competitors yet" while the query is still in flight.
  const isInitialLoading = isLoading && !data

  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Saved Competitors</h2>
      {isInitialLoading || pages.length > 0 ? (
        <Cards isLoading={isInitialLoading} pages={pages} />
      ) : (
        <div className={classes.emptyCard}>
          <AdLibraryEmptyState
            description={
              <>
                Competitors will appear here once you add them from the Ad
                Library section.
                <br />
                Search for brands and save them to
                <br />
                start tracking their activity and performance.
              </>
            }
            icon={SavedCompetitorsEmptyIcon}
            title="No competitors yet"
          />
        </div>
      )}
    </div>
  )
}
